export default __webpack_public_path__ + "static/media/702D936F-885E-462E-9146-0F430A15C003_1_105_c.e0c22788.jpeg";